import { render, staticRenderFns } from "./SearchActivityGoodsCard.vue?vue&type=template&id=cd8995d0&scoped=true"
import script from "./SearchActivityGoodsCard.vue?vue&type=script&lang=ts"
export * from "./SearchActivityGoodsCard.vue?vue&type=script&lang=ts"
import style0 from "./SearchActivityGoodsCard.vue?vue&type=style&index=0&id=cd8995d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd8995d0",
  null
  
)

export default component.exports